module.exports = __webpack_public_path__ + "img/春节大促_29.7bef3090.png";